import type { FloPayCardFields } from '@flopay/vue'

/**
 * The one file in the portal that reaches FloPay's browser SDK, `@flopay/vue` (os#1615), the way `flopay-client.ts` is
 * the one file in the API that reaches FloPay (AGENTS.md rule 5). Card entry happens only in FloPay's own fields, so
 * card data never touches the portal or the OS; the checkout form and the Billing view ask this file for the fields
 * and never import the SDK themselves.
 *
 * The SDK is loaded when the card fields are first shown rather than bundled with the portal. Where it cannot be
 * loaded the answer is null, and the form says card entry is unavailable instead of drawing a card input of its own.
 */
export type FloPayCardFieldsComponent = typeof FloPayCardFields

/** The SDK's module name, loaded at runtime. */
export const FLOPAY_VUE = '@flopay/vue'

/** How the SDK module is loaded: a dynamic import, so the SDK reaches the browser only on the checkout. */
export type SdkLoader = (specifier: string) => Promise<unknown>

const importSdk: SdkLoader = specifier => import(/* @vite-ignore */ specifier)

/** FloPay's card-field component, or null where the SDK is unavailable or does not offer it. */
export async function loadFloPayCardFields(load: SdkLoader = importSdk): Promise<FloPayCardFieldsComponent | null> {
    try {
        const sdk = (await load(FLOPAY_VUE)) as { FloPayCardFields?: FloPayCardFieldsComponent } | null
        return sdk?.FloPayCardFields ?? null
    } catch {
        return null
    }
}
